import React, { useMemo } from 'react';
import { Grid } from '@mui/material';
import AppPreviewMarketPlace from '@tenant/core/AppPreviewMarketPlace';
import moment from 'moment';
import { PRICE_TYPE_ENUM } from '@tenant/utility/constants/enum';
import { numberToCurrency } from '@tenant/utility/helper/Utils';
import PropTypes from 'prop-types';

const ConfirmStep = ({ values = {} }) => {
  const price = useMemo(
    () =>
      values.PriceType === PRICE_TYPE_ENUM['FREE']
        ? 'Free'
        : values.PriceType === PRICE_TYPE_ENUM['FLEXIBLE']
        ? 'PriceUponRequest'
        : `Monthly: ${numberToCurrency(
            parseFloat(values.MonthlyPrice),
          )} | Annual: ${numberToCurrency(parseFloat(values.AnnuallyPrice))}`,
    [values.PriceType, values.MonthlyPrice, values.AnnuallyPrice],
  );
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <AppPreviewMarketPlace
          isRating={false}
          iconBlobReference={
            values.IconFile && URL.createObjectURL(values.IconFile)
          }
          appUrl={values.IconBlobReference}
          shortDescription={values.ShortDescription}
          name={values.Name}
          keyLabels={values.KeyLabels}
          longDescription={values.LongDescription}
          keyBenefits={values.KeyBenefits}
          appVersion={values.AppVersionNumber}
          mobileAppVersion={values.MobileAppVersion}
          lastUpdated={new moment()}
          totalRating={values.TotalRating}
          categories={values.CategoryIds}
          dependencies={values.Dependencies}
          price={price}
          isPublic={values.IsPublic}
          metaTitle={values.MetaTitle}
          metaDescription={values.MetaDescription}
          priceType={values.PriceType}
          monthlyPrice={values.MonthlyPrice}
          annuallyPrice={values.AnnuallyPrice}
        />
      </Grid>
    </Grid>
  );
};

export default React.memo(ConfirmStep);

ConfirmStep.propTypes = {
  values: PropTypes.object,
};
